export function calcTotals(price, values) {
  let totalQuantity = 0;
  let totalPrice = 0;

  if (values) {
    totalQuantity = Object.keys(values).reduce((total, val) => {
      // Make sure to only grab updated quantities and not other values in the form
      const value = parseFloat(values[val]);
      if (!Number.isNaN(value)) {
        return total + value;
      }
      return total;
    }, 0);
    totalPrice = parseFloat(totalQuantity * price);
  }

  return { qty: totalQuantity, price: totalPrice };
}
